import { Directive, inject } from "@angular/core";
import { AlertService } from "./alert/alert.service";

@Directive()
export class BaseComponent {
  /* Commonly used services */
  protected readonly _alertService = inject(AlertService);
}
